import {
	SET_PAGO_DEDUCIBLE_AUTO,
	SET_GET_DETALLE_PAGO,
	ESTADO_INICIAL,
	SET_CFDI,
	SET_DATOS_EMITIR_CFDI,
	DISABLED_BUTTON_PAGO,
	RESET_PAGO_LINEA
} from "./pagoDeducibleAuto-actions";

const initialState = {
	cfdi: "",
	buttonPago: {
		inpNombreTitular: false,
		inpNumTarjeta: false,
		inpBanco: false,
		inpFchVencimiento: false,
		terminosCondiciones: false
	},
	pagoDeducibleAutos: {},
	getDetallePago: {
		monto: "",
		referenciaBancaria: "",
	},
	setEmitirCfdi: {
		datosFiscales: {
			isMoral: "",
			nombreCompleto: "",
			nombreRazon: "",
			apellidoPaterno: "",
			apellidoMaterno: "",
			rfc: "",
			domicilio: {},
		},
		datosTramite: {
			numPoliza: "",
			codSiniestro: "",
			carroceriaVehiculo: "",
			modelo: "",
			placas: "",
			concepto: "",
			monto: "",
			metodoPago: "",
			numeroTarjeta: "",
		},
	},
};

export function pagoDeducibleAutoRdc(state = initialState, action) {
	switch (action.type) {
	case ESTADO_INICIAL:
		return {
			...initialState,
		};
	case SET_DATOS_EMITIR_CFDI:
		return {
			...state,
			setEmitirCfdi: {
				datosFiscales: { ...action.payload.datosFiscales },
				datosTramite: { ...action.payload.datosTramite },
			},
		};
	case SET_CFDI:
		return { ...state, cfdi: action.payload };
	case SET_PAGO_DEDUCIBLE_AUTO:
		return { ...state, pagoDeducibleAutos: { ...action.payload } };
	case SET_GET_DETALLE_PAGO:
		return {
			...state,
			getDetallePago: {
				monto: action.payload.monto,
				referenciaBancaria: action.payload.referenciaBancaria,
			},
		};
	case DISABLED_BUTTON_PAGO:
		const buttonTemp = {...state.buttonPago};
		buttonTemp[action.payload.nameInput] = action.payload.inputValid;
		return{
			...state,
			buttonPago: {...buttonTemp}
		}
	case RESET_PAGO_LINEA:
		return{
			...state,
			buttonPago: {
				inpNombreTitular: false,
				inpNumTarjeta: false,
				inpBanco: false,
				inpFchVencimiento: false,
				terminosCondiciones: false
			}
		}
	default:
		return state;
	}
}



// WEBPACK FOOTER //
// ./src/pago-deducible-auto/pagoDeducibleAuto-reducer.js